export class QuizletImporter {
  static isQuizletData(txt: string): boolean {
    return txt.split('</l>').every((row) => row.includes('</q>') || row === '');
  }

  static importQuizlet(txt: string): string[][] {
    return txt.split('</l>').map((row) => row.split('</q>'));
  }
}
